import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import SymptomsSection from '../components/home/SymptomsSection';
import HowItHelpsSection from '../components/home/HowItHelpsSection';
import EducationalVideos from '../components/home/EducationalVideos';
import TreatmentSection from '../components/home/TreatmentSection';
import ComparisonTable from '../components/home/ComparisonTable';
import FAQSection from '../components/home/FAQSection';
import QuickContactForm from '../components/home/QuickContactForm';
import CTASection from '../components/home/CTASection';
import FloatingButtons from '../components/common/FloatingButtons';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <SymptomsSection />
        <HowItHelpsSection />
        <EducationalVideos />
        <TreatmentSection />
        <ComparisonTable />
        <FAQSection />
        <QuickContactForm />
        <CTASection />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default HomePage;
